import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const LineItemDataSchema = z.object({
  productId: z.string().optional(),
  variantId: z.string().optional(),
  productName: z.string().optional(),
  quantity: z.number(),
  amount: z.number(), // discountedTotalSet.shopMoney.amount as number
});

const OrderDataSchema = z.object({
  id: z.string(),
  name: z.string(),
  createdAt: z.string(),
  items: z.array(LineItemDataSchema),
  customerName: z.string(),
});

export const syncSalesData = unaryRpc({
  name: "syncSalesData" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date().optional(),
    createOrders: z.boolean().optional(),
  }),
  output: z.object({
    orders: z.array(OrderDataSchema),
    orderCount: z.number(),
    processedLineItems: z.number(),
    totalRevenue: z.number(),
    ordersRequiringAdditionalFetch: z.number(),
    ordersCreated: z.number(),
    ordersSkippedExisting: z.number(),
    ordersSkippedEmpty: z.number(),
    orderCreationErrors: z.number(),
  }),
});
